/**
 * chat_widget/src/widget/ui/Header.tsx
 */

import agentAvatar from "../../assets/avatar.png";
import TrashIcon from "../../assets/TrashIcon";

export default function Header({
  agentName,
  onClose,
  refreshSession,
}: {
  agentName: string;
  onClose: () => void;
  refreshSession: () => void;
}) {
  return (
    <div className="vcw-header">
      <div className="vcw-agent">
        <div className="vcw-avatar" aria-hidden="true">
          <img src={agentAvatar} alt="" className="vcw-avatar-img" />
          <span className="vcw-status" aria-hidden="true" />
        </div>
        <div className="vcw-title-wrapper">
          <div className="vcw-title">{agentName}</div>
          <div className="vcw-subtitle">En ligne</div>
        </div>
      </div>
      <div className="vcw-header-buttons">
        <button
          className="vcw-trash"
          onClick={refreshSession}
          aria-label="Fermer"
        >
          <TrashIcon />
        </button>
        <button className="vcw-close" onClick={onClose} aria-label="Fermer">
          ✕
        </button>
      </div>
    </div>
  );
}
